export const isMoreThanTwoWeeksFromNow = (inputDateString: string): boolean => {
  const inputDate = new Date(inputDateString);
  const now = new Date();
  const twoWeeksFromNow = new Date(now.getTime() + 14 * 24 * 60 * 60 * 1000);

  return inputDate > twoWeeksFromNow;
};
